module.exports = __webpack_public_path__ + "static/img/evaluaciones.94c1382a.png";